/** Minimum table width so percentage columns do not collapse in the empty-state frame. */
export const EXPERT_TRIAL_BALANCE_TABLE_MIN_WIDTH = '960px'

/** Shared width for Débit, Crédit, Solde and Solde N-1 — keeps the amount block visually even. */
export const EXPERT_TRIAL_BALANCE_AMOUNT_COLUMN_WIDTH = '10%'

/** Fixed px so PCG / auxiliary account numbers stay fully visible — % widths ellipsize in Lumen compact tables. */
export const EXPERT_TRIAL_BALANCE_COLUMN_WIDTHS = {
  accountNumber: '124px',
  amount: EXPERT_TRIAL_BALANCE_AMOUNT_COLUMN_WIDTH,
} as const
